import React, { useState } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import ModalEvent from "./ModalEvent";
import {
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from "@material-ui/lab";
import {
  Box,
  Typography,
  Paper,
  Chip,
  Button,
  makeStyles,
} from "@material-ui/core";
import OpacityIcon from "@material-ui/icons/Opacity";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DescriptionIcon from "@material-ui/icons/Description";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";

const useStyles = makeStyles((theme) => ({
  eventPaper: {
    textAlign: "left",
    padding: theme.spacing(2),
    borderRadius: 8,
  },
  tagChip: {
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  smallIconText: {
    display: "flex",
    alignItems: "center",
    gap: 6,
  },
  descriptionBox: {
    marginTop: 8,
    maxHeight: 50,
    overflow: "hidden",
    position: "relative",
    paddingRight: 10,

    // fade-out effect
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: 0,
      width: "100%",
      height: "10px",
      background: "linear-gradient(transparent, white)",
    }
  }
}));

const statusColorMap = {
  draft: "#f59e0b",     // amber-500
  internal: "#3b82f6",  // blue-500
  public: "#10b981",    // emerald-500
};

export default function EventItem({ event, isLast }) {
  const classes = useStyles();
  const history = useHistory();
  const [openEventModal, setOpenEventModal] = useState(false);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const handleOpenEvent = (event) => {
    setSelectedEvent(event);
    setOpenEventModal(true);
  };

  const handleCloseEvent = () => {
    setOpenEventModal(false);
    setSelectedEvent(null);
  };

  const areaLabels = (event.areas || []).map((a) => a.label).join(", ");

  return (
    <TimelineItem>
      <TimelineOppositeContent>
        <Typography color="textSecondary" variant="body2">
          {moment(event.start_date).format("D MMM YYYY")}
        </Typography>
      </TimelineOppositeContent>

      <TimelineSeparator>
        <TimelineDot style={{ backgroundColor: "#dc3545", color: "#fff" }}>
          <OpacityIcon />
        </TimelineDot>

        {!isLast && <TimelineConnector />}
      </TimelineSeparator>

      <TimelineContent>
        <Paper className={classes.eventPaper} elevation={1}>
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">
              {event.event_name || event.title}
            </Typography>

            <Chip
              label={event.status_name?.name || "-"}
              size="small"
              style={{
                backgroundColor:
                  statusColorMap[event.status] || "#6b7280", // fallback gray
                color: "#fff",
                fontWeight: 600,
                borderRadius: "999px",   // modern pill
                height: 24,
              }}
            />
          </Box>

          <Box mt={1} className={classes.smallIconText}>
            <CalendarTodayIcon style={{ fontSize: 16, color: "#1976d2" }} />
            <Typography variant="caption">
              {moment(event.start_date).format("D MMM YYYY")} - {moment(event.end_date).format("D MMM YYYY")}
            </Typography>
          </Box>
          <Typography
            variant="body2"
            color="textSecondary"
            className={classes.descriptionBox}
            style={{ marginTop: 8 }}
          >
            {event.description || "ไม่มีคำอธิบาย"}
          </Typography>

          <Box mt={1}>
            {(event.tags || []).map((tag) => (
              <Chip
                key={tag.id}
                label={tag.name}
                size="small"
                className={classes.tagChip}
                style={{
                  backgroundColor: tag.color,
                  color: "#fff",
                }}
              />
            ))}
          </Box>

          <Box mt={1} className={classes.smallIconText}>
            <LocationOnIcon style={{ fontSize: 16, color: "#1976d2" }} />
            <Typography variant="caption">
              {areaLabels || "ไม่มีพื้นที่"}
            </Typography>
          </Box>

          <Box mt={2} display="flex" gridGap={8}>
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<VisibilityIcon />}
              onClick={() => handleOpenEvent(event)}
            >
              ดูรายละเอียด
            </Button>

            <Button
              variant="outlined"
              color="primary"
              size="small"
              startIcon={<DescriptionIcon />}
              onClick={() => {
                if ((event.report_count || 0) > 0) {
                  history.push(`/${process.env.REACT_APP_PATH}reportwater/reports/${event.id}`);
                }
              }}
            >
              รายงาน ({event.report_count || 0})
            </Button>
          </Box>
        </Paper>
        <ModalEvent
          open={openEventModal}
          onClose={handleCloseEvent}
          event={selectedEvent}
        />
      </TimelineContent>
    </TimelineItem>
  );
}
